import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ChildMappedURL,
  hasPrefix,
  navDisplayText,
  PermissionsEnum,
  routerURLS,
  RoutesPermissionsEnum,
  submenuURL,
} from 'src/app/core/enumerations/permissions-enum';
import { UserType } from 'src/app/core/enumerations/user-type';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { IsauthorizedService } from 'src/app/shared/services/isauthorized.service';
import { Constants } from '../constants';
import { BroadcastService } from '../services/broadcast.service';
import { LocalStorageService } from '../services/local-storage.service';
import { LegalInfoService } from '../services/legal-info.service';
import { environment } from 'src/environments/environment';
import { LoggedInUserDto } from 'src/app/core/interfaces/loggedInUserDto';

export interface BUNavigationLink {
  displayName: string;
  url: string;
}


@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    standalone: false
})
export class ToolbarComponent implements OnInit, AfterViewInit {
  cdnImageUrl: string;
  isScreenSmall: Observable<boolean>;
  userName = '';
  manageUsersTitle = '';
  isManageuserActive: boolean;
  isEnableSubMenu: boolean;
  URL: string;
  matMenuLinks: LinkDetails[] = [];
  matmenuLinksCopy = [];
  submenuURLtext = submenuURL;
  isUserExternal: boolean;
  selectedLink: string;
  isMenuStillOpen: boolean;
  loggedInUserInfo: LoggedInUserDto;
  buNavigationLink: { displayName: string; url: string } | null = null;
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleOrderSidenav = new EventEmitter<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private breakpoints: BreakpointObserver,
    private broadcastService: BroadcastService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private localStorage: LocalStorageService,
    private readonly isauthorizedService: IsauthorizedService,
    private readonly legalInfoService: LegalInfoService
  ) {
    this.isScreenSmall = this.breakpoints
      .observe(`(max-width: ${Constants.SMALL_WIDTH_BREAKPOINT}px)`)
      .pipe(map((breakpoint) => breakpoint.matches));
    this.cdnImageUrl = environment.cdnImageServiceUrl;
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.broadcastService.linkPageActive.subscribe((event) => {
      const urlIndex = event.url.lastIndexOf('/');
      this.URL = event.url;
      this.selectedLink =
        ChildMappedURL[event.url] ||
        hasPrefix[event.url.substring(0, urlIndex)];
    });
    this.loggedInUserInfo = this.authenticationService.GetLoggedInUserDetails();
    this.isEnableSubMenu = this.enableSubMenu();
    this.isUserExternal = this.isExternalUser();
    this.matMenuLinks = this.generateNavLinks();
    this.loadBUNavigationLink(); 
    this.broadcastService.subscribe().subscribe((message) => {
      if (message.type === Constants.USERNAME_AT_TOOLBAR) {
        this.userName = this.displayUserName(message.payload);
      }
    });
  }

  public logout() {
    this.authenticationService.Logout();
  }

  getPageToRedirect() {
    this.router.navigate([Constants.HOME_TAB]);
  }

  getUserName() {
    if (this.userName) {
      return this.userName;
    } else {
      const loginUserInfo = this.loggedInUserInfo;
      if (loginUserInfo) {
        return this.displayUserName(loginUserInfo);
      }
    }
  }

  enableSubMenu() {
    const userPermission = this.authenticationService.GetUserPermissions();
    if (
      userPermission.includes(
        PermissionsEnum[PermissionsEnum.CanManageCustomerUsers]
      ) &&
      userPermission.includes(
        PermissionsEnum[PermissionsEnum.CanManageOtherInternalUsers]
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  enableSubMenuForOrder() {
    const userPermission = this.authenticationService.GetUserPermissions();
    const requiredPermissions = [
      PermissionsEnum.CanApproveOrders,
      PermissionsEnum.CanInputPOCResults
    ];
    let result = false;
    for (const permission of requiredPermissions) {
      if (userPermission.includes(permission)) {
        result = true;
        break;
      }
    }
    return result;
  }

  enableSubMenuForPurchaseOrder() {
    const userPermission = this.authenticationService.GetUserPermissions();
    if (
      userPermission.includes(
        PermissionsEnum[PermissionsEnum.CanViewPurchaseOrders]
      )
    ) {
      return true;
    }
  }

  navigateUserSubMenu() {
    const userPermission = this.authenticationService.GetUserPermissions();
    let link: string;
    if (
      userPermission.includes(
        PermissionsEnum[PermissionsEnum.CanManageCustomerUsers]
      ) ||
      userPermission.includes(
        PermissionsEnum[PermissionsEnum.CanManageOtherUsers]
      )
    ) {
      link = '/manage-customer-users';
    } else if (
      userPermission.includes(
        PermissionsEnum[PermissionsEnum.CanManageOtherInternalUsers]
      )
    ) {
      link = '/manage-internal-users';
    }
    return link;
  }

  isExternalUser() {
    if (this.loggedInUserInfo !== null) {
      return this.loggedInUserInfo.type.toLowerCase() === UserType[UserType.External].toLowerCase() ? true : false;
    } else {
      return false;
    }
  }

  removeActiveLinks() {
    this.matMenuLinks = this.matMenuLinks.map((data) => {
      data.isActive = false;
      return data;
    });
  }

  callLinksOnHover(index) {
    const preRef: any = this.broadcastService
      .getNavLinksRef()
      .filter((x) => x.indexOfRef === index)[0];
    if (preRef) {
      const alllinks = this.broadcastService.getNavLinksRef();
      preRef.ref.openMenu();
      alllinks.forEach((data) => {
        if (data.indexOfRef !== index) {
          data.ref.closeMenu();
        }
      });
    }
  }

  closeAllLinks() {
    setTimeout(() => {
      const alllinks = this.broadcastService.getNavLinksRef();
      alllinks.forEach((data) => {
        data.ref.closeMenu();
      });
    }, 500);
  }

  private generateNavLinks() {
    const matMenuLinks = [];
    const userPermission = this.authenticationService.GetUserPermissions();
    const authorizedControlList = this.prepareAuthorizedControlList();

    for (const link of authorizedControlList) {
      const linkDetails = new LinkDetails();
      const hasPermission: boolean = this.isauthorizedService.checkControlAuthorization(link.key);
      
      if (hasPermission && navDisplayText[link.key]) {
        this.populateLinkDetails(linkDetails, link, userPermission);
        this.addLinkToMenuLinks(matMenuLinks, linkDetails);
      }
    }

    this.updateConfigurationMenuLinks(matMenuLinks);
    return matMenuLinks.sort((a, b) => a.sequence - b.sequence);
  }

  private prepareAuthorizedControlList() {
    const authorizedControlList = JSON.parse(
      this.localStorage.getItem(Constants.AUTHORIZED_CONTROLS)
    );
    
    const removeAndAddControl = (key: string, group: string) => {
      const index = authorizedControlList.findIndex(x => x.key === key);
      if (index > -1) {
        authorizedControlList.splice(index, 1);
      }
      authorizedControlList.push({ groups: group, key: key });
    };

    removeAndAddControl('subTabManageAccounts', 'CanManageAccounts');
    removeAndAddControl('subTabViewAuditLogs', 'CanViewAuditLogs');

    return authorizedControlList;
  }

  private populateLinkDetails(linkDetails: LinkDetails, link: any, userPermission: string[]) {
    linkDetails.displayText = navDisplayText[link.key].split('_')[0];
    linkDetails.sequence = Number(navDisplayText[link.key].split('_')[1]);
    linkDetails.url = routerURLS[link.key];
    linkDetails.childUrl = [];

    this.setChildUrlsByLinkKey(linkDetails, link, userPermission);
  }

  private setChildUrlsByLinkKey(linkDetails: LinkDetails, link: any, userPermission: string[]) {
    const linkKey = link.key;

    if (linkKey === 'subTabManageUser') {
      this.handleManageUserLink(linkDetails);
    } else if (linkKey === 'subTabManageLabConfiguration') {
      linkDetails.childUrl = this.returnURLLists(RoutesPermissionsEnum.CanManageLabConfiguration);
    } else if (linkKey === 'SubTabRegisterLabels') {
      linkDetails.childUrl = this.returnURLLists(RoutesPermissionsEnum.CanRegisterLabels);
    } else if (linkKey === 'subTabOrders' || linkKey === 'subTabPurchaseOrder' || linkKey === 'subTabManagePackages') {
      this.handleOrdersLink(linkDetails, userPermission);
    } else if (linkKey === 'subTabManageProjects') {
      linkDetails.childUrl.push(...this.returnURLLists(RoutesPermissionsEnum.CanManageProjects));
    } else if (linkKey === 'subTabAnnouncements') {
      linkDetails.childUrl.push(...this.returnURLLists(RoutesPermissionsEnum.CanAnnouncement));
    } else if (linkKey === 'subTabManageAccounts') {
      linkDetails.childUrl.push(...this.returnURLLists(RoutesPermissionsEnum.CanManageAccounts));
    } else if (linkKey === 'subTabViewAuditLogs') {
      linkDetails.childUrl.push(...this.returnURLLists(RoutesPermissionsEnum.CanViewAuditLogs));
    }
  }

  private handleManageUserLink(linkDetails: LinkDetails) {
    linkDetails.displayText = navDisplayText.subTabManageLabConfiguration.split('_')[0];
    linkDetails.sequence = Number(navDisplayText.subTabManageLabConfiguration.split('_')[1]);
    
    if (this.enableSubMenu()) {
      for (const url in RoutesPermissionsEnum) {
        if (url === PermissionsEnum.CanManageCustomerUsers) {
          linkDetails.childUrl.push(RoutesPermissionsEnum.CanManageCustomerUsers);
        } else if (url === PermissionsEnum.CanManageOtherInternalUsers) {
          linkDetails.childUrl.push(RoutesPermissionsEnum.CanManageOtherInternalUsers);
        }
      }
    } else {
      linkDetails.childUrl.push(this.navigateUserSubMenu());
    }
  }

  private handleOrdersLink(linkDetails: LinkDetails, userPermission: string[]) {
  const hasCanPlaceOrders = userPermission.includes(PermissionsEnum[PermissionsEnum.CanPlaceOrders]);
  
  const isTgiBu = this.loggedInUserInfo?.businessUnits?.some(x => x.buCode.includes(Constants.BUCODE_TGI)) ?? false;
  
  if (hasCanPlaceOrders) {
    linkDetails.childUrl = [
      '/order/create-order',    // Place New Order
      '/order'                  // View Orders
    ];
    
    if (isTgiBu) {
      linkDetails.childUrl.push('STANDING_ORDERS');  // View Standing Orders
    }
    
    return;
  }

  const ordersPermissions = [
    PermissionsEnum.CanViewPurchaseOrders,
    PermissionsEnum.CanManagePackages
  ];
  
  if (!this.enableSubMenuForOrder() && !ordersPermissions.some(p => userPermission.includes(p))) {
    linkDetails.childUrl = [];
    return;
  }

  const permissionMappings = [
    { permission: PermissionsEnum.CanInputPOCResults, route: RoutesPermissionsEnum.CanInputPOCResults },
    { permission: PermissionsEnum.CanViewPurchaseOrders, route: RoutesPermissionsEnum.CanViewPurchaseOrders },
    { permission: PermissionsEnum.CanManagePackages, route: RoutesPermissionsEnum.CanManagePackages },
    { permission: PermissionsEnum.CanCreateBulkOrder, route: RoutesPermissionsEnum.CanCreateBulkOrder },
    { permission: PermissionsEnum.CanApproveOrders, route: RoutesPermissionsEnum.CanApproveOrders },
    { permission: PermissionsEnum.CanViewPatientResultForLA, route: RoutesPermissionsEnum.CanViewPatientResultForLA }
  ];

  permissionMappings.forEach(mapping => {
    if (userPermission.includes(mapping.permission)) {
      linkDetails.childUrl.push(...this.returnURLLists(mapping.route));
    }
  });
}

  private addLinkToMenuLinks(matMenuLinks: LinkDetails[], linkDetails: LinkDetails) {
    const existingConfiguration = matMenuLinks.find(t => t.displayText === 'Configuration');
    
    if (existingConfiguration && linkDetails.displayText === 'Configuration') {
      if (linkDetails.url && linkDetails.url !== '') {
        existingConfiguration.childUrl.push(linkDetails.url);
      } else {
        existingConfiguration.childUrl.push(...linkDetails.childUrl);
      }
    } else if ((linkDetails.displayText === 'Orders' && matMenuLinks.findIndex(x => x.displayText === 'Orders') === -1) ||
               linkDetails.displayText !== 'Orders') {

      matMenuLinks.push(linkDetails);
    }
  }

  private updateConfigurationMenuLinks(matMenuLinks: LinkDetails[]) {
    let userManagementLinks = '';
    
    matMenuLinks.forEach((element: LinkDetails) => {
      if (element.displayText === 'Configuration') {
        element.childUrl.forEach((res) => {
          if (res === '/manage-internal-users' || res === '/manage-customer-users') {
            userManagementLinks = userManagementLinks === '' ? res : `${userManagementLinks},${res}`;
          } else if (res === '/manage-accounts') {
            this.matmenuLinksCopy.push(userManagementLinks);
            userManagementLinks = res;
          } else {
            this.matmenuLinksCopy.push(res);
          }
        });
        this.matmenuLinksCopy.push(userManagementLinks);
        element.childUrl = this.matmenuLinksCopy;
      }
    });
  }

  private returnURLLists(permissionUrl) {
    const urlCollection = [];
    const urls = permissionUrl;
    const urlList = urls.split('||');
    for (const urlKey of urlList) {
      urlCollection.push(urlKey);
    }
    return urlCollection;
  }

  private displayUserName(payload) {
    return [payload.firstName, payload.middleInitial, payload.middleName, payload.lastName]
        .filter((val: string) => val && val.toString().length).join(' ');
  }

private loadBUNavigationLink() {
    // Get domain name at application level (not user level) - same pattern as Terms of Use and Privacy Policy
    const domainName = window.location.hostname;
     // Make API call to fetch BU navigation link configuration
  this.legalInfoService.getBuNavigationLink(domainName).subscribe({
    next: (config: any) => {
      try {
        if (config && config !== null && config !== '') {
          const link = JSON.parse(config);
          if (link.displayName && link.url) {
            this.buNavigationLink = {
              displayName: link.displayName,
              url: link.url
            };
          } else {
            this.buNavigationLink = null;
          }
        } else {
          this.buNavigationLink = null;
        }
      } catch (error) {
        this.buNavigationLink = null;
      }
    },
    error: () => {
      this.buNavigationLink = null;
    }
  });
 }
public openExternalLink(url: string){
  if(url){
    window.open(url, '_blank', 'noopener,noreferrer');
  }
 }

}

export class LinkDetails {
  url: string;
  childUrl: string[];
  displayText: string;
  sequence: number;
  isActive: boolean;
}
